export default "__VITE_ASSET__zaV0WOom__"